import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history } from '../../helpers/History';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import './styles.css'
import { Button, FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { DESCRICAO_USUARIO, DESCRICAO_SENHA, DESCRICAO_LOGIN } from '../../utils/constants'
import * as Constants from '../../utils/constants';
import * as loginAction from '../../services/login/Action';
import { ErrorMessage } from '../../components/UtilComponent';
import { RodapeImpressao } from '../../components/UtilComponent';


class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            mostrarSenha: false,
            isErro: false
        }
    }

    componentDidMount() {
        if (window.sessionStorage.getItem("token")) {
            this.props.history.push(Constants.ROUTE_URL_HOME);
        }
    }

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });
    };

    login = event => {

        return this.props.action.efetuarLoginAction(this.state).then((loginObject) => {
            this.props.history.push(Constants.ROUTE_URL_HOME);
            this.props.autenticar();
        }).catch((error) => {
            this.setState({
                isErro: true
            })
        });

    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.login();
        }
    }

    render() {
        return (
            <div className="login">
                <form>

                    {
                        this.state.isErro
                            ?
                            <ErrorMessage key='errorMessage' error={{ "ERRO": "Usuário ou senha incorretos" }} />
                            : ""
                    }

                    <FormGroup controlId="username">
                        <FormLabel>{DESCRICAO_USUARIO}</FormLabel>
                        <FormControl
                            autoFocus
                            type="text"
                            value={this.state.username}
                            onChange={this.handleChange('username')}
                        />
                    </FormGroup>
                    <FormGroup controlId="password">
                        <FormLabel>{DESCRICAO_SENHA}</FormLabel>
                        <FormControl
                            value={this.state.password}
                            onChange={this.handleChange('password')}
                            onKeyDown={this.onKeyDown}
                            type={this.state.mostrarSenha ? 'text' : 'password'}
                        />
                    </FormGroup>
                    <Button
                        block
                        onClick={(event) => { this.login() }}
                    >
                        {DESCRICAO_LOGIN}
                    </Button>
                </form>
                    <RodapeImpressao bottom={true}/>
            </div>
        );
    }
}


Login.propTypes = {
    autenticar: PropTypes.func.isRequired,
};


const mapStateToProps = state => ({
    loginObject: state.loginReducer.loginObject
});


const mapDispatchToProps = dispatch => ({
    action: bindActionCreators({ ...loginAction }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(Login);

